<template>
  <ModalStep
    :id="'program-objective-content'"
    :header="{
      title: programTitleRef,
    }"
    :onExitHandler="closeModal"
    data-test-id="program-objective-content-data"
  >
    <template #headerBeforeElement>
      <button class="modal-close-button" @click="closeModal" type="button" data-test-id="program-objective-close-button">
        <CrossIcon color="white" />
      </button>
    </template>
    <template #headerAfterElement>
      <div class="program-badge">
        {{ t('dashboard.shared.programProgress.programBadge') }}
      </div>
    </template>

    <template #bodyContent>
      <div
        class="program-objective-modal-content"
        data-test-id="program-objective-description"
        v-html="programDescriptionRef"
      ></div>
      <p>
        <span>{{ programDateRef }}</span>
      </p>
    </template>
    <template #footer>
      <div class="c-btns-container c-btn-center">
        <CustomButton
          usage="button"
          type="submit"
          color="white"
          :text="t('ui.button.close')"
          data-test-id="program-objective-close-button"
          @emit:click="closeModal"
        />
      </div>
    </template>
  </ModalStep>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useProgram from '@/features/programs/hooks/use-program.hook'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import CrossIcon from '@/features/ui/components/icons/cross-icon.vue'
import ModalStep from '@/features/ui/components/modal/modal-step/modal-step.vue'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { useI18n } from '@/lib/i18n'
import { getFullTimeRange } from '@/utils/dates'

const { t } = useI18n()

function closeModal() {
  modalsStore.toggleModal('program-objective', false)
}

const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)
const { programRef: selectedProgramRef } = useProgram(selectedProgramIdRef)

const programTitleRef = computed(() => {
  return selectedProgramRef.value?.name || ''
})

const programDescriptionRef = computed(() => {
  return selectedProgramRef.value?.description || ''
})

const programDateRef = computed(() => {
  return getFullTimeRange(
    selectedProgramRef.value?.latestPeriod?.startAt,
    selectedProgramRef.value?.latestPeriod?.endAt,
  )
})
</script>

<style lang="scss">
@import './program-objective-modal-content.scss';
</style>
